var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.sendMessageToIframe}},[_vm._v("sendToIframe")])])
}
var staticRenderFns = []

export { render, staticRenderFns }